"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeId = exports.updateNodeRevision = exports.getNodeRevision = void 0;
var revisionSymbol = '$r';
var IdSymbol = '$id';
var revision = 0;
var id = 0;
function getNodeRevision(node) {
    var mutableNode = node;
    if (mutableNode[revisionSymbol] === undefined) {
        initNodeRevisionDeep(mutableNode);
    }
    return mutableNode[revisionSymbol];
}
exports.getNodeRevision = getNodeRevision;
function updateNodeRevision(node) {
    revision++;
    updateNodeAndParentsRevision(node);
    return revision;
}
exports.updateNodeRevision = updateNodeRevision;
function getNodeId(node) {
    var mutableNode = node;
    if (mutableNode[IdSymbol] === undefined) {
        mutableNode[IdSymbol] = ++id;
    }
    return mutableNode[IdSymbol];
}
exports.getNodeId = getNodeId;
function initNodeRevisionDeep(node) {
    var mutableNode = node;
    mutableNode[revisionSymbol] = revision;
    if (node.type === 'rule' || node.type === 'root' || node.type === 'atrule') {
        node.walk(function (childNode) {
            childNode[revisionSymbol] = revision; // ToDo: not update if exist
        });
    }
}
function updateNodeAndParentsRevision(node) {
    var current = node;
    do {
        current[revisionSymbol] = revision; // ToDo: stop if already at revision
        current = current.parent;
    } while (current);
}
//# sourceMappingURL=mutable-ast.js.map